/**
 * matrix targets some old browsers via babel/preset-env which in turn applies the babel/plugin-transform-runtime on their compiled code
 * this transformed compilation requires the regenerator-runtime in order to run properly (must be loaded before everything else)
 * todo: we should remove this once no compiled deps requires this anymore
 * see the babel plugin docs + https://github.com/babel/babel/issues/9849#issuecomment-487040428
 */
import 'regenerator-runtime/runtime';
// following recommend pattern https://webpack.js.org/concepts/module-federation/#troubleshooting
import('./bootstrap');
